define("specific/filtermanager/templates/filtermanager", [], function() { return Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div class=\"maz-filter-wrapper\">\r\n</div>\r\n";
},"useData":true}); });